<template>
  <div>
    <vs-table
      v-if="launchPre[0] != null"
      class="pd-table"
      :max-items="descriptionItems[0]"
      pagination
      :data="launchPre"
      description
      :description-items="descriptionItems"
      description-title="Registros"
      description-connector="de"
      description-body="Mostrar"
      search
    >
      <template slot="thead">
        <th> Atendimento/Pré </th>
        <th> Aluno/Responsável </th>
        <th> Curso </th>
        <th> Contatos </th>
        <th> Status </th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="b__important">
              {{ data[indextr].CODATENDIMENTO }} -
              {{ data[indextr].IDPREMATRICULA }}
            </div>
          </vs-td>

          <vs-td>
            <div class="b__important">
              {{ data[indextr].NOME.toUpperCase() }}
            </div>
            <div>
              RA: {{ data[indextr].RA }} <br>
              CPF: {{ data[indextr].CPF }}
            </div>
            <div class="b__small">
              ({{ data[indextr].CODCLIENTE }}) {{ data[indextr].NOMECLIENTE.toUpperCase() }}
            </div>
          </vs-td>

          <vs-td>
            <div class="b__small">{{ data[indextr].CURSO }}</div>
          </vs-td>

          <vs-td>
            <div>
              <div class="b__small" style="display: flex; margin-bottom: 5px;">
                <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                  email
                </span>
                <span>
                  {{ data[indextr].EMAIL }}
                </span>
              </div>
              <div v-if="data[indextr].TELEFONE1" class="b__small" style="display: flex;">
                <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                  phone
                </span>
                <span>
                  {{ data[indextr].TELEFONE1 }}
                </span>
              </div>
              <div v-if="data[indextr].TELEFONE2" class="b__small" style="display: flex;">
                <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                  phone
                </span>
                <span>
                  {{ data[indextr].TELEFONE2 }}
                </span>
              </div>
              <div v-if="data[indextr].TELEFONE3" class="b__small" style="display: flex;">
                <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                  phone
                </span>
                <span>
                  {{ data[indextr].TELEFONE3 }}
                </span>
              </div>
            </div>
          </vs-td>

          <vs-td>
            <div style="margin-bottom: 5px;" :class="formatParcel(data[indextr].STATUSLAN)">
              {{ data[indextr].STATUSLANCAMENTO }}
            </div>
            <div class="b__small" style="display: flex;">
              <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                event
              </span>
              <span>
                {{ data[indextr].DTVENCIMENTO | moment }}
              </span>
            </div>
            <div class="b__small" style="display: flex;" v-if="data[indextr].DATABAIXA != '[object Object]'">
              <span style="font-size: 12.5px; margin-right: 2.5px;" class="material-icons">
                check_circle
              </span>
              <span>
                {{ data[indextr].DATABAIXA | moment }}
              </span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-alert
      color="danger"
      icon="new_releases"
      v-else
    >
      <b>Sem resultados para serem mostrados</b>
    </vs-alert>
  </div>
</template>

<script>
import PreRegistration from "../../services/preRegistration";

export default {
  name: "InstallmentsMonth",
  data: () => ({
    descriptionItems: [10, 50, 100],
    myPreRegistation: [],
    launchPre: [],
    dueDate: null,
    error: null,
    message: null,
    successDisposal: false,
  }),

  mounted() {
    this.$vs.loading({});
    new PreRegistration()
    .searchPreWithLaunch()
    .then((res) => {
      this.launchPre = res.data;
    })
    .catch((response) => {
      if (response && response.data) {
        this.notify.error = response.data.error;
        this.$vs.notify({
          title: "Um erro foi encontrado",
          text: this.notify.error,
          color: "danger",
        });
      }
    })
    .finally(() => {
      this.$vs.loading.close();
    });
  },

  methods: {
    formatParcel(status) {
      switch (status) {
        case "V":
          return 'vencido';
        case "A":
          return 'aberto';
        case "P":
          return 'pago';
        case "M":
          return 'venceHoje';
      }
    },
  }
};
</script>

<style scope>
.vencido {
  color: #ff0000;
}
.aberto {
  color: #0000ff;
}
.pago {
  color: #008000;
}
.venceHoje {
  color: #ffa500;
}
.vencido,
.aberto,
.pago,
.venceHoje {
  font-weight: bold;
}
.icon-whats {
  color: green;
  cursor: pointer;
}
.vs-col {
  padding: 10px;
  font-size: 0.8rem;
}
.h100 {
  line-height: 30px;
}
.text-left {
  text-align: left;
}
.b__important {
  font-weight: bolder;
}
.b__small {
  font-size: 10px;
  color: #607d8b;
}
.invicible {
  visibility: hidden;
}
.vs-popup {
  width: 700px;
}
.vs-popup--content {
  margin: 0;
  padding: 0;
}
.flex-gap {
  gap: 10px;
}
</style>
